import useClinicUser from 'shared/hooks/useClinicUser';
import { GraphQLFetchPolicies } from 'shared/enums/GraphQLFetchPolicies';
import { GetClinicStripeInfoQuery, useGetClinicStripeInfoQuery } from 'shared/types/graphql';
import { FeatureFlagName } from 'shared/enums/FeatureFlagName';
import useFeatureFlag from './useFeatureFlag';

export const useBillingInfo = (): {
  displayBilling: boolean;
  getDisplayBilling: () => Promise<boolean>;
} => {
  const { hasAdminRoleAtCurrentClinic, currentClinicId } = useClinicUser();
  const { isFeatureEnabled } = useFeatureFlag();

  const { data, refetch } = useGetClinicStripeInfoQuery({
    variables: {
      where: { id: currentClinicId },
    },
    skip: !hasAdminRoleAtCurrentClinic,
    fetchPolicy: GraphQLFetchPolicies.CacheAndNetwork,
  });

  const hasStripeInfo = (query?: GetClinicStripeInfoQuery): boolean => {
    if (!query) return false;

    const stripeInfo = data?.findUniqueClinic;
    return Boolean(stripeInfo?.stripeCustomerId) && isFeatureEnabled(FeatureFlagName.StripeBillingPortal);
  };

  const getDisplayBilling = async (): Promise<boolean> => {
    if (!hasAdminRoleAtCurrentClinic) return false;

    const { data } = await refetch();

    return hasStripeInfo(data);
  };

  return {
    displayBilling: hasStripeInfo(data),
    getDisplayBilling,
  };
};
